import { FC, Fragment } from "react";

interface HasFieldCellProps {
  hasField: boolean;
}

export const HasFieldCell: FC<HasFieldCellProps> = ({ hasField }) => {
  return <Fragment>{hasField ? "Yes" : "No"}</Fragment>;
};
